import React from "react"
import { PDFMinEntryHeight, PDFSectionBorder } from "./PDF"
import { PDFHeadedSection } from "./PDFSection"

const lines = 5

export function NotesPDFSection({ text}: { text?: string;}): JSX.Element {
    return (
        <PDFHeadedSection title={"Mechanic's Notes"}>
            {text?.trim() ? (
                <div style={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere", paddingTop: "5px" }}>{text}</div>
            ) : (
                // Blank work order: keep ruled lines for handwritten notes.
                Array(lines)
                    .fill(null)
                    .map((_, i) => (
                        <div key={i} style={{ height: PDFMinEntryHeight, borderBottom: PDFSectionBorder, paddingTop: "5px" }} />
                    ))
            )}
        </PDFHeadedSection>
    )
}
